import React from "react";
import dayjs from "dayjs";

const CancelStatusCard = ({ item }) => {

    const status = Number(item.business_order_cancel_status);

    let bg = "#fff7ed";
    let border = "#fdba74";
    let badge = "#f97316";
    let title = "Cancellation Requested";
    let desc = `Requested Qty: ${item.business_order_cancel_item_qty}`;

    if (status === 1) {
        bg = "#ecfdf5";
        border = "#6ee7b7";
        badge = "#10b981";
        title = "Cancellation Approved";
        desc = `Approved Qty: ${item.business_order_cancel_item_qty}`;
    }

    if (status === 2) {
        bg = "#fef2f2";
        border = "#fca5a5";
        badge = "#ef4444";
        title = "Cancellation Rejected";
        desc = `Your cancellation request was rejected`;
    }

    return (
        <tr>
            <td colSpan="6">
                <div
                    style={{
                        marginTop: "10px",
                        background: bg,
                        border: `1px solid ${border}`,
                        borderRadius: "10px",
                        padding: "14px 18px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                    }}
                >
                    <div style={{ textAlign: "left" }}>
                        <h6 style={{ margin: 0, fontWeight: 600 }}>{title}</h6>
                        <small>{desc}</small>

                        {item.business_order_cancel_approve_date && (
                            <div style={{ fontSize: "12px", marginTop: "4px" }}>
                                Date : {dayjs(item.business_order_cancel_approve_date).format("DD MMM YYYY hh:mm A")}
                            </div>
                        )}

                        {item.business_order_cancel_remark && (
                            <div style={{ fontSize: "12px", marginTop: "4px" }}>
                                Remark : {item.business_order_cancel_remark}
                            </div>
                        )}
                    </div>

                    <span
                        style={{
                            background: badge,
                            color: "#fff",
                            padding: "6px 14px",
                            borderRadius: "20px",
                            fontSize: "12px"
                        }}
                    >
                        {title}
                    </span>
                </div>
            </td>
        </tr>
    );
};

export default CancelStatusCard;